import { makeStyles } from '@material-ui/core/styles';

import { FONTS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 400,
    },
    dialogContent: {
      padding: theme.spacing(6, 4, 4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    title: {
      fontWeight: theme.typography.fontWeightBold,
      fontFamily: FONTS.DMSans,
      textAlign: 'center',
      margin: theme.spacing(2, 0, 1),
    },
    button: {
      width: '100%',
      marginTop: theme.spacing(4),
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  }),
  { name: 'BetaIntegrationPopup' }
);
